import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容导航',
    links: [
      { label: '生长习性', path: '/category/shengzhang-xixing' },
      { label: '种植方法', path: '/category/zhongzhi-fangfa' },
      { label: '养护技巧', path: '/category/yanghu-jiqiao' },
      { label: '科学原理', path: '/category/kexue-yuanli' },
      { label: '常见问题', path: '/category/changjian-wenti' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <span className="w-8 h-8 flex items-center justify-center text-xl">
                  <i className="ri-plant-line text-primary-500"></i>
                </span>
                <span className="font-heading text-lg font-semibold text-foreground-900">
                  害羞草指南
                </span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed">
                最全面的中文害羞草（含羞草）种植养护知识平台。
                <br />
                从科学原理到实操技巧，助你轻松种出这株神奇植物。
              </p>
            </div>
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h5 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
                  {group.title}
                </h5>
                <ul className="flex flex-col gap-2">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 害羞草指南 —— 触碰即合的神奇植物完全指南
            </p>
            <p className="text-xs text-foreground-400">
              本站内容仅供学习参考，不构成专业园艺建议
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}